import { render, staticRenderFns } from "./VirtualBackground.vue?vue&type=template&id=c6588714&scoped=true&"
import script from "./VirtualBackground.vue?vue&type=script&lang=js&"
export * from "./VirtualBackground.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pc/side_menu.css?vue&type=style&index=0&id=c6588714&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6588714",
  null
  
)

export default component.exports